function getSiteMaintenance() {
    InFlight.CMS.getSiteMaintenance().then(function (resp) {
        if (!(resp && resp.length)) {
            return;
        }
        
        window.location.href = "/pages/maintenance.html";
    });
}

getSiteMaintenance();